import { gql } from 'apollo-client-ppc';

export const fetchPaymentMethodsForOrderReview = gql`
  query fetchPaymentMethodsForOrderReview($id: ID!) {
    transactionAccount(id: $id) {
      id
      updatePaymentMethodLink
      availablePaymentMethods {
        totalCount
        nodes {
          id
          paymentIssue
          type
          default
          ... on CreditCard {
            card {
              expirationMonth
              expirationYear
              last4Numbers
              brand
              cardHolderName
            }
          }
          ... on PaymentOnTerms {
            terms {
              invoiceDueDays
            }
          }
        }
      }
      customerBalances {
        usd
      }
    }
  }
`;
